import React, { useEffect, useReducer, useState} from 'react';
import {Container, Row,Button, Nav, Accordion} from 'react-bootstrap'
import { Link } from 'react-router-dom';
import Footer from './Footer';
import Header from './Header';

import "../stylesheets/style.css"
import "../stylesheets/navbar.css"
import "../js/main.js"
import Testimonials from './Testimonials';
import Faq from './Faq';
import Contact from './Contact'
import Navbar from './Navbar';
import TopBar from "./TopBar"
import BookOptions from './BookOptions';

const Home = () => {
    useEffect(() =>{
        document.title = "Home | Earth VIII Apartments"
    },[])
    var usertoken = localStorage.getItem("accesstoken")
    if(usertoken ===null){window.location.replace("/signin");}
  

    return (



<div class="wrapper">
<Navbar/>
<div id="content">

<TopBar/>
<hr/>
<BookOptions/>
    
<br/>
<br/>
<br/>
<div class="row">


<div class="col-md-4">
<Nav.Link as={Link} to="/bookanapartment" eventKey="10">
  <img className="img-fluid dashhomecard" src="./images/webapp/1.png"/>
  </Nav.Link>
</div>


<div class="col-md-4 mobilerow">
<img className="img-fluid dashhomecard"  src="./images/webapp/2.png"/>
</div>

<div class="col-md-4 mobilerow">
<img className="img-fluid dashhomecard"  src="./images/webapp/3.png"/>
</div>

</div>

<div class="row webapphmsecondbox">


<div class="col-md-4">
<img className="img-fluid dashhomecard"  src="./images/webapp/4.png"/>
</div>
<div class="col-md-4">
<img className="img-fluid dashhomecard mobilerow"  src="./images/webapp/5.png"/>
</div>

<div class="col-md-4">
<img className="img-fluid dashhomecard mobilerow"  src="./images/webapp/6.png"/>
</div>
</div>

<br/>
<br/>

  </div>   

</div>


  
    )


}


export {Home as default}